import { IMonitoringRepository } from "../../domain/monitoring/monitoring-repository";
import { HttpService } from "../http/http";
import { Injectable } from "@angular/core";

@Injectable()
export class MonitoringRepository implements IMonitoringRepository {
  constructor(private _httpService: HttpService) {}
  generateAvailabilityChartUrl(
    availabilityZoneIds: number[],
    chartWidth: number,
    chartHeight: number,
    historyMinutes: number,
    graphDurationSecs: number,
    timeTagFormat: string,
    vertLineEvery: number,
    hoursInstead: boolean,
  ): string {
    const availabilityZoneIdsConcatenated = availabilityZoneIds
      ? availabilityZoneIds.join()
      : "";
    const timestamp = new Date().valueOf();
    return (
      this._httpService.endpoint +
      `reports/GetAvailabilityZonesChart?availabilityZones=${availabilityZoneIdsConcatenated}&&graphDurationSecs=${graphDurationSecs}&timeTagFormat=${timeTagFormat}&vertLineEvery=${vertLineEvery}&hoursInstead=${hoursInstead}&historyMinutes=${historyMinutes}&chartWidth=${chartWidth}&chartHeight=${chartHeight}&timestamp=${timestamp}`
    );
  }

  generateChannelTargetChartUrl(
    platformId: number,
    availabilityZoneId,
    chartWidth: number,
    chartHeight: number,
    historyMinutes: number,
    graphDurationSecs: number,
    timeTagFormat: string,
    vertLineEvery: number,
    hoursInstead: boolean,
  ): string {
    const timestamp = new Date().valueOf();
    return (
      this._httpService.endpoint +
      `reports/GetChannelTargetChart?availabilityZoneId=${availabilityZoneId}&platformId=${platformId}&graphDurationSecs=${graphDurationSecs}&timeTagFormat=${timeTagFormat}&vertLineEvery=${vertLineEvery}&hoursInstead=${hoursInstead}&historyMinutes=${historyMinutes}&chartWidth=${chartWidth}&chartHeight=${chartHeight}&timestamp=${timestamp}`
    );
  }
}
